import { Injectable } from '@angular/core';

import { Factory } from './factory.interface';
import {
    Unit, Property, Investor, Contract, Insurance, TypeUnit
} from '../Classes';
import { Unit as UnitT, UnitsSummary } from '../Interfaces';
import { ParkingSpaceFactory } from './parking-space-factory';
import { UnitPhotoFactory } from './unit-photo-factory';
import { WarehouseFactory } from './warehouse-factory';
import { TypeUnitFactory } from './type-unit-factory';

@Injectable()
export class UnitFactory implements Factory {
    constructor(
        private psf: ParkingSpaceFactory,
        private whf: WarehouseFactory,
        private upf: UnitPhotoFactory,
        private tuf: TypeUnitFactory
    ) { }
    createInstance(json?: (UnitT | any), summary?: UnitsSummary): Unit {
        return new Unit(
            json, new Property(json.property), new Investor(json.investor),
            new Contract(json.contract), new Insurance(json.insurance),
            this.psf.createInstances((json.parking_spaces) ? json.parking_spaces : []),
            this.whf.createInstances((json.warehouses) ? json.warehouses : []),
            new TypeUnit(json.type_unit),
            this.upf.createInstances((json.photos) ? json.photos : []),
            summary
        );
    }

    createInstances(jsons: (UnitT | any)[]): Unit[] {
        let instances: Unit[] = [];
        jsons.forEach(json => {
            instances.push(this.createInstance(json, json.summary));
        });
        return instances;
    }
    deps() {
        return ['ParkingSpaceFactory', 'WarehouseFactory', 'UnitPhotoFactory'];
    }
}
export const UnitFactoryProviders = [
    ParkingSpaceFactory, WarehouseFactory, UnitPhotoFactory,
    {
        provide: UnitFactory, useClass: UnitFactory,
        deps: ParkingSpaceFactory, WarehouseFactory, UnitPhotoFactory
    }
];
export const UnitFactoryDeps = [
    ParkingSpaceFactory, WarehouseFactory, UnitPhotoFactory
];



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Factories/unit-factory.ts